import { shade } from "polished";
import styled, { css } from "styled-components";

import { size } from "~/styles/screen";
import { Input as DashboardInput } from "~/templates/dashboard/dashboard/components/styles";

interface Props {
  userIsAuthenticated: boolean;
}

export const BlurredDiv = styled.div<Props>`
  ${(props) =>
    !props.userIsAuthenticated &&
    css`
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
      filter: blur(10px);
    `}
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const GreenBox = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 200px;
  margin: auto;
  left: 0;
  right: 0;
  background: #f1fdef;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 30px;

  @media screen and (max-width: ${size.small}) {
    justify-content: flex-start;
    align-items: center;
    padding: 15px;
    height: 250px;
  }
`;

export const GreenBoxTitle = styled.text`
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  font-family: "Montserrat";
`;

export const GreenBoxSubTitle = styled.text`
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  font-family: "Montserrat";
  margin-top: 4px;
`;

export const GreenBoxButton = styled.button`
  background: #f1fdef;
  border: 1px solid #72e85f;
  box-sizing: border-box;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  width: 215px;
  height: 40px;
  cursor: pointer;
  margin-top: 20px;
  transition: background 0.2s;
  &:hover {
    background: ${shade(0.1, "#f1fdef")};
  }

  @media screen and (max-width: ${size.small}) {
    width: 80%;
    height: 25%;
  }
`;
export const GreenBoxButtonText = styled.text`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 120%;
  text-align: center;
  text-transform: uppercase;
  color: #41e029;
`;

export const CompaniesTitle = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Input = styled(DashboardInput)`
  flex-basis: 300px;
`;
